// File: src/components/SubmenuBar.jsx
import React, { useEffect, useRef, useState } from "react";
import "./SubmenuBar.scss";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DiamondIcon from "../../Icons/DiamondIcon.jsx";
import InventoryIcon from "../../Icons/InventoryIcon.jsx";
import ReportIcon from "../../Icons/ReportIcon.jsx";
import StocktakeIcon from "../../Icons/StocktakeIcon.jsx";
import TransactionIcon from "../../Icons/TransactionIcon.jsx";
const INVENTORY_PAGES = new Set([
  "summary",
  "myinventory",
  "reservelist",
  "skumovement",
  "skumovementdetails",
  "stockidmovement",
  "stockidmovementdetails",
  "itemsearch",
  "lowstockplanning",
  "zone",
  "createreserves",
  "createreserve",
  "posorder",
  "quickview",
  "transactionhistory",
]);

const resolveActiveTab = (pathname) => {
  const parts = (pathname || "").split("/").filter(Boolean);
  const moduleName = (parts[1] || "").toLowerCase();
  const page = (parts[2] || "").toLowerCase();

  if (moduleName === "users") {
    if (page === "roles") return "Roles";
    if (page === "userlogreport" || page === "operationlogreport") return "Report";
    return "Users";
  }

  if (page === "report") return "reserve_tab";
  if (INVENTORY_PAGES.has(page)) return "dropdownMenuinventory";
  if (page === "diamondsearch" || page === "detaildiamond" || page === "creatediamond" || page === "stonesearch" || page === "createcolorstone" || page === "createcolorstonereserve") return "diamondSearch_tab";
  if (page === "stocktake" || page === "stocktake-scan") return "Stocktake_tab";
  return "transaction_tab";
};

const SubmenuBar = (props) => {
    const { t } = useTranslation();
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

    const generalsettings = useSelector((state) => state.app.generalsettings)
    const dropdownRef = useRef(null);
    const [isActive, setIsActive] = useState(false);
    const { pathname } = useLocation();
    const parts = pathname.split("/");
    const nav = parts?.[2] ?? "inventory";
    const routeActiveTab = resolveActiveTab(pathname);
    const [isProductMovementActive, setIsProductMovementActive] = useState(false);
    const [isInventoryActive, setIsInventoryActive] = useState(false);
    const gemstonesRef = useRef(null);
    const [isGemstonesActive, setIsGemstonesActive] = useState(false);

    const closeInventoryMenu = () => {
        setIsInventoryActive(false);
        setIsProductMovementActive(false);
        setIsGemstonesActive(false);
    };

    useEffect(() => {
        closeInventoryMenu();
        // eslint-disable-next-line
    }, [pathname]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsActive(false);
                setIsInventoryActive(false);
                setIsProductMovementActive(false);
            }
            if (gemstonesRef.current && !gemstonesRef.current.contains(event.target)) {
                setIsGemstonesActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line
    }, []);

    const toggleProductMovementDropdown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsProductMovementActive((prevState) => !prevState);
    };
    const toggleInventoryDropdown = (e) => {
        e.preventDefault();
        setIsInventoryActive((prevState) => !prevState);
        setIsProductMovementActive(false);
        setIsGemstonesActive(false);
    };
    const toggleGemstonesDropdown = (e) => {
        e.preventDefault();
        setIsGemstonesActive((prevState) => !prevState);
        setIsInventoryActive(false);
        setIsProductMovementActive(false);
    };
    return (
        <nav className="SubmenuBar navbar navbar-expand-lg navbar-dark">
            <div className="collapse navbar-collapse" id="main_nav">


                <ul className="navbar-nav mx-auto">
                    {nav === "inventory" ? (
                        <>
                            <li
                                className={parmissiondatashow?.purchase_order?.View ||
                                    parmissiondatashow?.inventory_transaction_purchase?.View ||
                                    parmissiondatashow?.inventory_transaction_stock_transfer?.View ||
                                    parmissiondatashow?.inventory_transaction_stock_Receive?.View
                                    ? "nav-item" : "d-none"}
                                onClick={closeInventoryMenu}
                            >
                                <Link
                                    id="transaction_tab"
                                    className={`hoverSVGpathColor ${routeActiveTab === 'transaction_tab' ? "dataActive active" : "dataActive"}`}
                                    to="/app/inventory"
                                >
                                    <TransactionIcon></TransactionIcon>
                                    {t("Transaction")}
                                </Link>
                            </li>
                            <li className="nav-item" ref={dropdownRef}>
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className={`InventoryDropdown dropdown-toggle ${routeActiveTab === 'dropdownMenuinventory' ? "dataActive active" : "dataActive"}`}
                                        onClick={toggleInventoryDropdown}
                                        type="button"
                                        id="dropdownMenuinventory"
                                        aria-expanded={isInventoryActive ? "true" : "false"}
                                    >
                                        <InventoryIcon width={18} height={18} />
                                        {t("Inventory")}
                                    </Link>
                                    <ul className={`dropdown-menu ${isInventoryActive ? "show" : ""}`}>
                                        <li onClick={closeInventoryMenu} className="dropdown-toggle">
                                            <Link className={parmissiondatashow?.Summary?.View ? "dropdown-item" : "d-none"} to="/app/inventory/summary">{t("Summary")}</Link>
                                        </li>
                                        <li onClick={closeInventoryMenu}>
                                            <Link className={parmissiondatashow?.my_inventory?.View ? "dropdown-item" : "d-none"} to="/app/inventory/myInventory">{t("My Inventory")}</Link>
                                        </li>
                                        <li onClick={closeInventoryMenu}>
                                            <Link className={parmissiondatashow?.reserve_list?.View ? "dropdown-item" : "d-none"} to="/app/inventory/reserveList">{t("Reserve List")}</Link>
                                        </li>
                                        <li
                                            className={parmissiondatashow?.sku_analysis?.View || parmissiondatashow?.stock_analysis?.View ? "hover-sub-dropdown" : "d-none"}
                                            onClick={toggleProductMovementDropdown}
                                        >
                                            <Link className="dropdown-item dropdown-toggle cursor-pointer" aria-expanded={isProductMovementActive ? "true" : "false"}>
                                                {t("Product Movement")}
                                                <img className="menu-arrow" src={base_assets + "images/icons/menu-arrow.png"} alt="" />
                                            </Link>
                                            <ul className={`dropdown-menu dropdown-menu-end child-menu ${isProductMovementActive ? "show" : ""}`}>
                                                <li className={parmissiondatashow?.sku_analysis?.View ? "dropdown-item" : "d-none"} onClick={(e) => { e.stopPropagation(); closeInventoryMenu(); }}>
                                                    <Link className="dropdown-item" to="/app/inventory/skumovement">{t("SKU")}</Link>
                                                </li>
                                                <li className={parmissiondatashow?.stock_analysis?.View ? "dropdown-item" : "d-none"} onClick={(e) => { e.stopPropagation(); closeInventoryMenu(); }}>
                                                    <Link className="dropdown-item" to="/app/inventory/stockidmovement">{t("Stock ID")}</Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li onClick={closeInventoryMenu}>
                                            <Link to="/app/inventory/itemSearch" className={parmissiondatashow?.item_search?.View ? "dropdown-item" : "d-none"}>{t("Item Search")}</Link>
                                        </li>
                                        <li onClick={closeInventoryMenu}>
                                            <Link to="/app/inventory/lowStockPlanning" className={parmissiondatashow?.Low_Stock_Planning?.View ? "dropdown-item" : "d-none"}>{t("Low Stock Planning")}</Link>
                                        </li>
                                        <li onClick={closeInventoryMenu}>
                                            <Link to="/app/inventory/zone" className="dropdown-item">{t("Zone")}</Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            {
                                <li data-id="diamondSearch_tab"
                                    ref={gemstonesRef}
                                    className={generalsettings?.data?.generalsetup?.productChoice === '1' ?
                                        parmissiondatashow?.inventory_diamond_search?.View ? "nav-item" : "d-none" : "d-none"}
                                >
                                    <div className="dropdown">
                                        <Link
                                            to="#"
                                            id="diamondSearch_tab"
                                            className={`dropdown-toggle ${routeActiveTab === 'diamondSearch_tab' ? "dataActive active" : "dataActive"}`}
                                            onClick={toggleGemstonesDropdown}
                                            type="button"
                                            aria-expanded={isGemstonesActive ? "true" : "false"}
                                        >
                                            <DiamondIcon></DiamondIcon>
                                            {t("Gemstones")}
                                        </Link>
                                        <ul className={`dropdown-menu ${isGemstonesActive ? "show" : ""}`}>
                                            <li onClick={closeInventoryMenu}>
                                                <Link className="dropdown-item" to="/app/inventory/diamondSearch">{t("Diamond")}</Link>
                                            </li>
                                            <li onClick={closeInventoryMenu}>
                                                <Link className="dropdown-item" to="/app/inventory/stoneSearch">{t("Color Stones")}</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            }
                            <li
                                className={parmissiondatashow?.stock_take?.View ? "nav-item" : "d-none"}
                                onClick={closeInventoryMenu}
                            >
                                <Link className={routeActiveTab === 'Stocktake_tab' ? "dataActive active" : "dataActive"} id="Stocktake_tab" to="/app/inventory/stocktake-scan">
                                    <StocktakeIcon />
                                    {t("Stock take")}
                                </Link>
                            </li>
                            <li
                                className={parmissiondatashow?.inventory_reports?.View ? "nav-item" : "d-none"}
                                onClick={closeInventoryMenu}
                            >
                                <Link
                                    className={`hoverSVGpathColor ${routeActiveTab === 'reserve_tab' ? "dataActive active" : "dataActive"}`}
                                    id="reserve_tab"
                                    to="/app/inventory/report/reserve"
                                >
                                    <ReportIcon></ReportIcon>
                                    {t("Report")}
                                </Link>
                            </li>
                        </>
                    ) : nav === "product" ? (
                        <>

                        </>
                    ) : nav === "POS" ? (
                        ""
                    ) : nav === "users" ? (
                        <>

                            <li
                                className={parmissiondatashow?.User?.View ? "nav-item" : "d-none"}
                                onClick={closeInventoryMenu}
                            >
                                <Link
                                    className={routeActiveTab === 'Users' ? "dataActive active" : "dataActive"}
                                    id="Users"
                                    to="/app/users"
                                >
                                    {t("Users")}
                                </Link>
                            </li>
                            <li
                                className={parmissiondatashow?.user_roles?.View ? "nav-item" : "d-none"}
                                onClick={closeInventoryMenu}
                            >
                                <Link
                                    className={routeActiveTab === 'Roles' ? "dataActive active" : "dataActive"}
                                    id="Roles"
                                    to="/app/users/roles"
                                >
                                    {t("Roles")}
                                </Link>
                            </li>
                            <li className={parmissiondatashow?.user_reports?.View ? "nav-item" : "d-none"} ref={dropdownRef}>
                                <div
                                    className="dropdown"
                                    onClick={() => {
                                        setIsActive(!isActive);
                                    }}
                                >
                                    <Link
                                        className={routeActiveTab === 'Report' ? "dropdown-toggle dataActive active " : "dropdown-toggle dataActive"}
                                        type="button"
                                        id="Report"
                                        data-bs-toggle="dropdown"
                                        aria-expanded={isActive ? "true" : "false"}
                                    >
                                        {t("Report")}
                                    </Link>
                                    <ul className={`dropdown-menu dropdown-menu-end ${isActive ? 'show' : ''}`}>
                                        <li className="dropdown-toggle" onClick={() => setIsActive(false)}>
                                            <Link className="dropdown-item"
                                                id="Report"
                                                to="/app/users/UserLogReport"
                                            >
                                                {t("User Log")}
                                            </Link>
                                        </li>
                                        <li className="dropdown-toggle" onClick={() => setIsActive(false)}>
                                            <Link className="dropdown-item"
                                                id="Report"
                                                to="/app/users/OperationLogReport"
                                            >
                                                {t("Operation Log")}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                        </>
                    ) : ""}
                </ul>



            </div>
        </nav>

    );
};

export default SubmenuBar;
